
















import Vue from 'vue';
import { FileUploadBox } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { ProuniDocument } from '@/store/modules/prouni/types';

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  name: 'ProuniFileUpload',
  components: { FileUploadBox },
  props: {
    documentType: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    familyMemberId: {
      type: Number,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    initialDone: {
      type: Boolean,
      default: false,
    },
    // Whether to prefill the "done" state from an already-uploaded document in
    // the store (matched by type + family member). Disabled for free-form
    // ("other") uploads, whose type is not unique per application.
    matchExisting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    // Reflect an already-uploaded document (persisted in the store) so the field
    // shows as done — with its file name — when the step is re-mounted (e.g. after
    // navigating back via the pipeline menu).
    const documents = (this.$store.getters.prouniDocuments || []) as ProuniDocument[];
    const existing = this.matchExisting
      ? documents.find(
          document =>
            document.documentType === this.documentType &&
            (document.familyMemberId || null) === (this.familyMemberId || null),
        )
      : undefined;
    return {
      done: this.initialDone || Boolean(existing),
      currentFileName: this.initialFileName || (existing && existing.fileName) || '',
      errorMessage: '',
      isUploading: false,
      maxFileSize: FIVE_MB_IN_BYTES,
    };
  },
  methods: {
    async uploadHandler(file: File): Promise<void> {
      this.errorMessage = '';
      this.isUploading = true;
      try {
        const document: ProuniDocument = await this.$store.dispatch('UPLOAD_PROUNI_DOCUMENT', {
          file,
          documentType: this.documentType,
          familyMemberId: this.familyMemberId,
          description: this.description,
        });
        this.done = true;
        this.currentFileName = file.name;
        this.$emit('uploaded', document);
        this.$emit('input', true);
      } catch (error) {
        this.errorMessage = i18n.t('prouni.upload.genericError') as string;
        this.$emit('input', false);
      } finally {
        this.isUploading = false;
      }
    },
    deleteHandler(): void {
      this.done = false;
      this.currentFileName = '';
      this.errorMessage = '';
      this.$emit('input', false);
      this.$emit('delete', this.documentType);
    },
    errorHandler(error: 'type' | 'size'): void {
      this.errorMessage = i18n.t(`fileUploadError.${error}`) as string;
    },
  },
});
